import React, { Component } from 'react';
import {
  Scheduler,
  WeekView,
  MonthView,
  Appointments,
  AppointmentTooltip,
  DateNavigator,
  Toolbar
} from '@devexpress/dx-react-scheduler-material-ui';
import { FormControlLabel, Radio, RadioGroup, Paper, Box, IconButton } from '@mui/material';
import { AllDayPanel, ViewState } from '@devexpress/dx-react-scheduler';
import { Fragment } from 'react';
import { SCHCOLORS } from '../../../utils/generalFuncs';
import AppointmentContent, { Appointment } from '../../common/TSElements/AppointmentContent';
import AppointmentHeader from '../../common/TSElements/AppointmentHeader';
import { SingleRadio } from '../../common/RadioAndCheckbox';
import { CloudDownloadRounded } from '@mui/icons-material';

class Schedule extends Component {
    state = { 
        currentViewName: "Month",
        // appointments: []
    }
    componentDidMount = async () => {
        // if(isEmpty(this.props.PROJECTS)){
        //     await this.props.fetchProjects()
        // }
        // if(isEmpty(this.props.TIMESHEETS)){
        //     await this.props.fetchTimesheets()
        // }
        // this.getList()
    }
    getList = () => {
        const { PROJECTS, TIMESHEETS } = this.props;
        let appointments = []

        Object.values(TIMESHEETS).forEach(element => {
            let tmp = Object.assign({}, element)
            tmp.color = tmp.color || SCHCOLORS[tmp.event_type]

                if (tmp.event_type === "PROJECT"){
                    tmp.title = PROJECTS[tmp.project_id] && PROJECTS[tmp.project_id].project_name
                }
                appointments.push(tmp)
        })

        // this.setState({appointments})
        return appointments
    }
    
    render() {
        const { currentViewName } = this.state;

        let appointments = this.getList()
        // console.log({appointments, currentViewName}, this.props);
        return (
            <Box p={1}>
                <Box style={{ display: "flex", justifyContent: "space-between"}}>
                    <RadioGroup
                        aria-label="Vues"
                        style={{ flexDirection: 'row' }}
                        name="views"
                        value={currentViewName}
                        onChange={(e) => this.setState({ currentViewName: e.target.value})}
                    >
                        <SingleRadio value="Month" label="Mois" />
                        <SingleRadio value="Week" label="Semaine" />
                    </RadioGroup>
                </Box>
                <Paper>
                    <Scheduler
                        data={appointments}
                        currentViewName={currentViewName}
                        locale={"fr-FR"}
                    >
                        <ViewState
                            defaultCurrentDate={new Date()}
                        />
                        {currentViewName === "Week" &&
                            <WeekView
                                startDayHour={7.5}
                                endDayHour={22.5}
                            />
                        }
                        {currentViewName === "Month" &&
                            <MonthView />
                        }
                        <Toolbar />
                        <DateNavigator />
                        <Appointments 
                            appointmentComponent={Appointment}
                        />
                        <AppointmentTooltip
                            headerComponent={AppointmentHeader}
                            contentComponent={AppointmentContent}
                            showCloseButton
                        />
                        {/* <AllDayPanel /> bug */} 
                    </Scheduler>
                </Paper>
            </Box>
        );
    }
}

export default Schedule;
